import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ApprovalsEquipmentsApi } from '@core/api/approvals-equipments/approvals-equipments.api';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { CustomMessagesService } from '@core/errors/custom-messages.service';

import english from './../../i18n/en.json';
import spanish from './../../i18n/es.json';
import portuguese from './../../i18n/pt.json';

@Component({
  selector: 'dialog-approvals-approve',
  templateUrl: './dialog-approvals-approve.component.html',
  styleUrls: ['./dialog-approvals-approve.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogApprovalsEquipmentsApproveComponent {
  public approveForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public approval: any,
    public matDialogRef: MatDialogRef<DialogApprovalsEquipmentsApproveComponent>,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private approvalsEquipmentsApi: ApprovalsEquipmentsApi,
    private fuseProgressBarService: FuseProgressBarService,
    private customMessageService: CustomMessagesService,
    private formBuilder: FormBuilder
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.approveForm = this.formBuilder.group({ message: [''] });
  }

  public acceptApproval(): void {
    this.fuseProgressBarService.show();
    this.approvalsEquipmentsApi
      .acceptEquipment(this.approval.id, this.approveForm.value.message)
      .subscribe((approvedApproval) => {
        this.fuseProgressBarService.hide();
        if (approvedApproval) {
          this.customMessageService.success('APPROVALS_EQUIPMENTS.DIALOG.EQUIPMENT_SUCCESSFULLY_APPROVED');
          this.matDialogRef.close(true);
        }
      });
  }
}
